/*
 * Шел мокапа. Усі кеглі й висоти — з `styles/tokens.css`; піксельних розмірів тут немає
 * навмисно, бо «крок комфорту» має бути зміною однієї змінної, а не двадцяти правил.
 *
 * Нижче 1280 сайдбар згортається в іконки. Ширину задає токен `--sidebar-w`, який
 * перемикається в тому ж @media у tokens.css, тож тут лишається тільки те, що ховається.
 */

.root {
  display: flex;
  min-height: 100vh;
  width: 100%;
  background: var(--bg);
}

.sidebar {
  width: var(--sidebar-w);
  flex: none;
  background: var(--bg-side);
  border-right: 1px solid var(--line);
  display: flex;
  flex-direction: column;
  position: sticky;
  top: 0;
  height: 100vh;
}

.brand {
  padding: var(--sp-5) var(--sp-5) var(--sp-4);
  border-bottom: 1px solid var(--line);
  display: flex;
  align-items: center;
  gap: var(--sp-3);
}

.logo {
  width: 28px;
  height: 28px;
  flex: none;
  border-radius: var(--r-md);
  background: var(--g);
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--on-accent);
  font-family: 'IBM Plex Mono', monospace;
  font-size: var(--fs-cell);
  font-weight: 700;
}

.brandName {
  font-size: var(--fs-cell);
  font-weight: 600;
  line-height: var(--lh-tight);
  letter-spacing: -0.01em;
  color: var(--t1);
}

.brandMeta {
  font-family: 'IBM Plex Mono', monospace;
  font-size: var(--fs-micro);
  line-height: var(--lh-tight);
  color: var(--t8);
}

.nav {
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  padding: var(--sp-3) var(--sp-2) var(--sp-4);
  display: flex;
  flex-direction: column;
  gap: var(--sp-3);
}

.groupTitle {
  padding: var(--sp-2) var(--sp-3) var(--sp-1);
  font-family: 'IBM Plex Mono', monospace;
  font-size: var(--fs-micro);
  font-weight: 600;
  line-height: var(--lh-tight);
  letter-spacing: var(--ls-label);
  color: var(--t9);
  text-transform: uppercase;
}

.navItem {
  display: flex;
  align-items: center;
  gap: var(--sp-3);
  min-height: var(--ctl-h);
  padding: var(--sp-2) var(--sp-3);
  border-radius: var(--r-md);
  font-size: var(--fs-base);
  font-weight: 500;
  line-height: var(--lh-snug);
  color: var(--t6);
  background: transparent;
  cursor: pointer;
  text-decoration: none;
}

.navItem:hover {
  background: var(--hover);
  color: var(--t1);
}

.navItem[data-active] {
  background: var(--active);
  color: var(--t0);
}

.navIcon {
  width: 16px;
  flex: none;
  text-align: center;
  font-family: 'IBM Plex Mono', monospace;
  font-size: var(--fs-small);
  font-weight: 500;
  color: var(--t9);
}

.navItem[data-active] .navIcon {
  color: var(--g);
}

.navLabel {
  flex: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.navBadge {
  font-family: 'IBM Plex Mono', monospace;
  font-size: var(--fs-small);
  font-variant-numeric: tabular-nums;
  color: var(--t9);
}

.navItem[data-active] .navBadge {
  color: var(--t6);
}

.sidebarFooter {
  padding: var(--sp-3) var(--sp-3) var(--sp-3);
  border-top: 1px solid var(--line);
  display: flex;
  flex-direction: column;
  gap: var(--sp-2);
  flex: none;
}

.switcher {
  display: flex;
  gap: var(--sp-1);
  padding: 3px;
  background: var(--sub);
  border: 1px solid var(--line);
  border-radius: var(--r-lg);
}

.switchButton {
  flex: 1;
  text-align: center;
  min-height: var(--ctl-h-sm);
  padding: var(--sp-2) var(--sp-1);
  border-radius: var(--r-sm);
  font-family: 'IBM Plex Mono', monospace;
  font-size: var(--fs-small);
  font-weight: 600;
  letter-spacing: var(--ls-label);
  color: var(--t8);
  background: transparent;
  cursor: pointer;
}

.switchButton[data-active] {
  background: var(--g);
  color: var(--on-accent);
}

/* Компактний перемикач теми: у DOM завжди, показується тільки коли сайдбар згорнутий. */
.switchCompact {
  display: none;
  align-items: center;
  justify-content: center;
  min-height: var(--ctl-h);
  border-radius: var(--r-md);
  border: 1px solid var(--line);
  background: var(--sub);
  color: var(--t6);
  font-size: var(--fs-base);
  cursor: pointer;
}

.switchCompact:hover {
  color: var(--t0);
  background: var(--hover);
}

.avatar {
  width: 26px;
  height: 26px;
  flex: none;
  border-radius: 50%;
  background: var(--avatar);
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: 'IBM Plex Mono', monospace;
  font-size: var(--fs-micro);
  font-weight: 600;
  color: var(--t6);
}

.userName {
  font-size: var(--fs-cell);
  font-weight: 500;
  line-height: var(--lh-snug);
  color: var(--t1);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.userRole {
  font-family: 'IBM Plex Mono', monospace;
  font-size: var(--fs-micro);
  line-height: var(--lh-snug);
  color: var(--t8);
}

.logout {
  color: var(--t8);
  font-size: var(--fs-base);
  padding: var(--sp-1) var(--sp-2);
  border-radius: var(--r-sm);
  cursor: pointer;
}

.logout:hover {
  color: var(--r-txt);
  background: var(--hover);
}

.main {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
}

.header {
  position: sticky;
  top: 0;
  z-index: 5;
  background: var(--bg-blur);
  backdrop-filter: blur(8px);
  border-bottom: 1px solid var(--line);
  min-height: var(--header-h);
  padding: var(--pad-header);
  display: flex;
  align-items: center;
  gap: var(--sp-5);
}

/* Чіп черги тримається правого краю шапки, як у мокапі. */
.headerRight {
  margin-left: auto;
}

/* Мертві роботи в шапці: протилежне за змістом до «в черзі», тож і колір інший. */
.queueDead {
  font-family: 'IBM Plex Mono', monospace;
  font-size: var(--fs-small);
  color: var(--r-txt);
}

.screenTitle {
  font-size: var(--fs-title);
  font-weight: 600;
  line-height: var(--lh-snug);
  letter-spacing: -0.01em;
  white-space: nowrap;
  color: var(--t1);
}

.screenCrumb {
  font-family: 'IBM Plex Mono', monospace;
  font-size: var(--fs-small);
  line-height: var(--lh-snug);
  color: var(--t8);
}

.content {
  flex: 1;
  padding: var(--sp-6) var(--sp-6) 40px;
  min-width: 0;
}

/*
 * 768–1279. Сайдбар лишається на місці (він і є навігація), але втрачає підписи.
 * Ховаємо текст, а не звужуємо його: обрізаний підпис читається як помилка рендера.
 */
@media (max-width: 1279px) {
  .brand {
    padding: var(--sp-4) 0;
    justify-content: center;
  }

  .brandText,
  .groupTitle,
  .navLabel,
  .navBadge,
  .userText,
  .switcher {
    display: none;
  }

  .switchCompact {
    display: flex;
  }

  .nav {
    padding: var(--sp-3) var(--sp-2);
    align-items: center;
  }

  .navItem {
    width: var(--ctl-h);
    justify-content: center;
    padding: var(--sp-2);
  }

  .navIcon {
    font-size: var(--fs-base);
  }

  .sidebarFooter {
    padding: var(--sp-3) var(--sp-2);
    align-items: center;
  }

  .userRow {
    flex-direction: column;
    gap: var(--sp-2);
  }

  .header {
    padding: var(--sp-4) var(--sp-5);
    gap: var(--sp-4);
  }

  .content {
    padding: var(--sp-5) var(--sp-5) 40px;
  }
}
